const PeriodoAtivoEnum = {
  FORADOPERIODO: 0,
  PROPOSTA: 1,
  REFORMULACAO: 2,
}

export default PeriodoAtivoEnum
